export default {
    rick_event_highlights: "Eventos Destacados",
    risk_event_distribution: "Distribución de Eventos de Riesgo",
    risk_events_grouped_by_driver: "Eventos de Riesgo, Agrupados por Conductor",
    risk_events_grouped_by_tag: "Eventos de Riesgo, Agrupados por Etiqueta",
    risk_no_data: "No hay datos disponibles",
    risk_events_by_driver_tag: "Etiqueta",
    risk_events_by_tag_title: "Eventos de Riesgo, Agrupados por Etiqueta",
    risk_events_by_tag_group: "Grupo",
    risk_events_by_tag_avg_events: "Evento de Riesgo Promedio",
    risk_events_by_tag_risk: "Puntuación de Riesgo",
    risk_events_by_tag_events: "Total Eventos",
    risk_events_by_tag_distance: "Distancia",
    risk_events_trends_title: "Tendencias de Eventos de Riesgo",
    risk_events_trends_event_type: "Tipo de Evento",
    risk_events_by_driver_label: "Conductor",
    risk_events_by_driver_avg_events: "Evento de Riesgo Promedio",
    risk_events_by_driver_risk: "Puntuación de Riesgo",
    risk_events_by_driver_events: "Total Eventos",
    risk_events_by_driver_distance: "Distancia",
    risk_events_by_driver_global: "Configuración de filtros GLOBALES (afecta a TODOS los gadgets)",
    risk_events_by_driver_clear_global: "Eliminar todos los filtros globales y restablecer todos los gadgets",
    risk_events_by_driver_clear_specific: "Borrar los filtros personalizados de este gadget (se usarán filtros globales)",

    // Pending Coaching Case Gadget
    pending_coaching_case: "Casos de entrenamiento pendientes",
    pending_coach_case_id: "ID de Caso",
    pending_coach_case_status: "Estado",
    pending_coach_case_coach: "Coach",
    pending_coach_case_status_next_step: "Siguiente Paso",
    pending_coach_case_created_on: "Creado el",
    pending_coach_case_status_pending: "Pendiente",
    pending_coach_case_status_evaluate: "Evaluar",
    pending_coach_case_status_completed: "Completado",
    pending_coach_case_status_escalate: "Escalado",
    pending_coach_case_next_step_assign_coach: "Asignar Supervisor",
    pending_coach_case_next_step_initiate_coaching: "Iniciar Supervisión",
    pending_coach_case_next_step_monitor: "Monitorear",
    pending_coach_case_next_step_pi_omited: "PI Omitido",
    pending_coach_case_next_step_pi_successfull: "PI Exitoso",
    pending_coach_case_next_step_judgement: "Juicio",
    pending_coach_case_next_step_pi_failed: "PI Fallido",

    // Resumen de Casos de Coaching
    cases_coaching_summary: "Resumen de Casos (Entrenamiento)",
    cases_coaching_summary_pending: "Pendientes",
    cases_coaching_summary_evaluation: "Evaluar",
    cases_coaching_summary_completed: "Completados",
    cases_coaching_summary_avgDuration: "Duración Promedio",
    cases_coaching_summary_pISuccessRat: "Tasa de Éxito PI",
    cases_coaching_summary_eligibleDrivers: "Conductores Elegibles",
    cases_coaching_summary_daysToComplete: "Días para Completar",
    cases_coaching_summary_createNew: "Crear Nuevo",

    // Coaching de Desempeño del Conductor
    driver_performance_coach: "Entrenamiento del desempeño del conductor",
    driver_performance_coach_coachName: "Supervisor",
    driver_performance_coach_pendingCount: "Cantidad Pendiente",
    driver_performance_coach_lastCoaching: "Último Entrenamiento",
    driver_performance_coach_avgPendingCount: "Promedio Pendientes",
    driver_performance_coach_avgDurationDays: "Duración Promedio (Días)",
    driver_performance_coach_piSuccessRatePercent: "Tasa de Éxito PI",

    //Active Coaching Cases
    driver_performance_active_coaching_cases: "Casos de Entrenamiento Activos",
    driver_performance_coach_caseNumber: "Número de Caso",
    driver_performance_coach_status: "Estado",
    driver_performance_coach_nextStep: "Siguiente Paso",
    driver_performance_coach_createdOn: "Creado",
    driver_performance_coach_daysPending: "Días Pendientes",
    driver_performance_coach_alert: "Alertas",

    // Filtro de Jerarquía (RiskEventsByTag)
    risk_events_by_tag_hierarchy: "Jerarquía",
    risk_events_by_tag_hierarchy_placeholder: "Seleccionar jerarquía",
    risk_events_by_tag_level: "Nivel",
    risk_events_by_tag_level_placeholder: "Seleccionar nivel",
    risk_events_by_tag_no_hierarchy: "Sin jerarquía (todos los tags)",
    risk_events_by_tag_hierarchy_config: "Jerarquía de Tag",

    // Tooltips de Información de Fechas por Gadget
    gadget_date_info_all_records: "Todos los registros (sin filtro de fecha aplicado)",
    gadget_date_info_CasesCoachingSummary: "El resumen de Casos (Coaching) muestra todos los casos sin importar la fecha. Este número seguirá incrementando con el tiempo.",
    gadget_date_info_PendingCoachingCase: "Muestra todos los casos de coaching pendientes sin importar la fecha.",
    gadget_date_info_ActiveCoachingCases: "Muestra los casos con estado Pendiente, Monitoreo o Juicio sin importar la fecha.",
    gadget_date_info_DriverPerformanceCoach: "Muestra métricas de rendimiento de todos los casos por coach sin importar la fecha.",

};
